// extracted by mini-css-extract-plugin
export default {"container":"Sticky_container__Ev4Q","fixed":"Sticky_fixed_oo0s9","title":"Sticky_title_QQo4i","column":"Sticky_column_Mc6O0"};